import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withStyles, Chip } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import ClearIcon from '@material-ui/icons/Clear';
import Select from 'react-select';
import Option from './Option';

const styles = (theme) => ({
  chip: {
    margin: theme.spacing(0.25),
  },
});

const SelectWrapped = ({
  classes,
  intl,
  creatable,
  ...other
}) => {
  if (creatable) {
    return (
      <Select.Creatable
        optionComponent={Option}
        arrowRenderer={() => null}
        clearRenderer={() => <ClearIcon />}
        promptTextCreator={(label) => intl.formatMessage({
          id: 'Choose option',
          defaultMessage: 'Choose option "{label}"',
        }, { label })}
        valueComponent={(valueProps) => {
          const { value, children, onRemove } = valueProps;

          const onDelete = (event) => {
            event.preventDefault();
            event.stopPropagation();
            onRemove(value);
          };

          if (onRemove) {
            return (
              <Chip
                tabIndex={-1}
                label={children}
                className={classes.chip}
                deleteIcon={<CancelIcon onTouchEnd={onDelete} />}
                onDelete={onDelete}
              />
            );
          }

          return <div className="Select-value">{children}</div>;
        }}
        {...other}
      />
    );
  }

  return (
    <Select
      optionComponent={Option}
      arrowRenderer={() => null}
      clearRenderer={() => <ClearIcon />}
      valueComponent={(valueProps) => {
        const { value, children, onRemove } = valueProps;

        const onDelete = (event) => {
          event.preventDefault();
          event.stopPropagation();
          onRemove(value);
        };

        if (onRemove) {
          return (
            <Chip
              tabIndex={-1}
              label={children}
              className={classes.chip}
              deleteIcon={<CancelIcon onTouchEnd={onDelete} />}
              onDelete={onDelete}
            />
          );
        }

        return <div className="Select-value">{children}</div>;
      }}
      {...other}
    />
  );
};

SelectWrapped.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  inputRef: PropTypes.func.isRequired,
  creatable: PropTypes.bool,
};

export default injectIntl(withStyles(styles)(SelectWrapped));
